export default __webpack_public_path__ + "static/media/logo.8d90bad0.svg";